import { render } from "./AdsBrokerageConfigurationEditing.vue?vue&type=template&id=36b9fbc4&scoped=true&ts=true"
import script from "./AdsBrokerageConfigurationEditing.vue?vue&type=script&lang=ts"
export * from "./AdsBrokerageConfigurationEditing.vue?vue&type=script&lang=ts"

import "./AdsBrokerageConfigurationEditing.vue?vue&type=style&index=0&id=36b9fbc4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b9fbc4"]])

export default __exports__